/* eslint-disable no-undef */
import { useEffect, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { AiOutlineDelete } from 'react-icons/ai';
import { FaPlus } from 'react-icons/fa';
import { GrCertificate } from 'react-icons/gr';
import { TiTick } from 'react-icons/ti';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
// import CertificateBuilder from '../../Events/CertificateBuilder/CertificateBuilder';
// import { toast } from 'react-toastify';
import { clearTable } from '../../../../Redux/slices/table';
import {
  // createDefaultCertificate,
  deleteDefaultCertificate,
  editDefaultCertificate,
  fetchDefaultCertificate
} from '../../../../Redux/slices/defaultCertificate';
import ReactTableRender from '../../../../Components/ReactTable/ReactTableRender';
import { useFilters, usePagination, useSortBy, useTable } from 'react-table';
import DefaultColumnFilter from '../../../../Components/ReactTable/Filters/DefaultColumnFilter';
import { mediaUrlify, toNepaliNumber } from '../../../../_helpers/_methods';

function DefaultCertificateTemplate() {
  const dispatch = useDispatch();
  const local = useSelector((state) => state.local.local);
  const defaultCertificates = useSelector((state) => state.defaultCertificate.defaultCertificates);
  const [pageNum, setPageNum] = useState(1);
  const totalCount = useSelector((state) => state.events.totalCount);
  const loading = useSelector((state) => state.events.loading);
  const gotoPage = (page) => {
    setPageNum(page);
  };

  const defaultColumn = useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter
    }),
    []
  );
  const handleDefaultCertificateDelete = (id) => {
    dispatch(deleteDefaultCertificate(id, local));
  };

  const handleMakeDefault = (result) => {
    let data = { is_default: true };
    dispatch(editDefaultCertificate(result.id, data, local));
  };

  const columns = useMemo(
    () => [
      {
        Header: <FormattedMessage id="sn" />,
        accessor: 'serial_number',
        disableFilters: true,
        width: '7%'
      },

      {
        Header: <FormattedMessage id="template_title" />,
        accessor: 'template_title'
      },
      {
        Header: <FormattedMessage id="preview" />,
        disableFilters: true,
        accessor: 'preview',
        width: '20%'
      },

      {
        Header: <FormattedMessage id="actions" />,
        disableFilters: true,
        accessor: 'actions'
      }
    ],
    []
  );

  const data = useMemo(() => {
    if (defaultCertificates) {
      let count = 1;
      return defaultCertificates.map((result) => {
        let action = (
          <div className="d-flex">
            <div className="mx-2">
              {result.is_default ? (
                <Button variant="success ">
                  <TiTick />
                  <FormattedMessage id="button.activated" />
                </Button>
              ) : (
                <Button variant="outline-success " onClick={() => handleMakeDefault(result)}>
                  <TiTick />
                  <FormattedMessage id="button.activate" />
                </Button>
              )}
            </div>
            {!result.is_default && (
              <div className='"mx-2'>
                <Button
                  variant="outline-danger "
                  onClick={() => handleDefaultCertificateDelete(result.id)}>
                  <AiOutlineDelete />
                </Button>
              </div>
            )}
          </div>
        );
        const preview = (
          <div>
            <img
              style={{ width: '400px', height: '400px', objectFit: 'contain' }}
              src={mediaUrlify(result.image)}
              alt={result.title}
            />
          </div>
        );
        return {
          serial_number: local === 'ne' ? toNepaliNumber(count++) : count++,
          template_title: result.title,
          preview: preview,
          actions: action
        };
      });
    }
  }, [defaultCertificates]);

  const {
    headerGroups,
    getTableProps,
    getTableBodyProps,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageCount,
    nextPage,
    previousPage,
    visibleColumns,
    setPageSize,
    state: { pageIndex, pageSize }
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 50 },
      manualPagination: true,
      pageCount: pageNum,
      defaultCanFilter: false,
      defaultColumn,
      disableSortBy: false
      // manualFilters: true
    },
    useFilters,
    useSortBy,
    usePagination
  );

  const pageCountArray = useMemo(
    () => Array.from({ length: Math.ceil(totalCount / pageSize) }, (v, i) => i + 1),
    [totalCount, pageSize]
  );
  useEffect(() => {
    dispatch(fetchDefaultCertificate({ index: pageNum, pageSize: pageSize }));
  }, []);
  useEffect(() => {
    return () => {
      dispatch(clearTable());
    };
  }, []);
  const [showCertificateBuilder, setShowCertificateBuilder] = useState(false);

  // const handleSaveCertificateTemplate = async (formData) => {
  //   try {
  //     dispatch(createDefaultCertificate(formData, handleHideCertificateBuilder, local));
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleShowCertificateBuilder = () => setShowCertificateBuilder(true);
  // const handleHideCertificateBuilder = () => setShowCertificateBuilder(false);
  return (
    <div className="card content-section p-3">
      <div className="card-header d-flex justify-content-between align-items-end">
        <h4 className="d-inline-block text-primary">
          <StyledCertificateIcon color={'#2378f9'} size={35} /> &nbsp;
          <FormattedMessage id="certificate_template" />
        </h4>
        <div className="d-flex justify-content-between align-items-end">
          <Button
            variant="primary"
            onClick={handleShowCertificateBuilder}
            disabled={showCertificateBuilder}>
            <FaPlus size={18} className="me-2" />
            <FormattedMessage id="add_new" />
          </Button>
        </div>
      </div>
      <hr />

      <div>
        {showCertificateBuilder && (
          <>
            {/* <CertificateBuilder onSave={handleSaveCertificateTemplate} isDefaultCreator={true} /> */}
          </>
        )}
      </div>
      <div className="">
        <ReactTableRender
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          totalCount={totalCount}
          gotoPage={gotoPage}
          previousPage={previousPage}
          pageCount={pageCount}
          pageCountArray={pageCountArray}
          pageNum={pageNum}
          showGoto={true}
          nextPage={nextPage}
          pageIndex={pageIndex}
          canNextPage={canNextPage}
          canPreviousPage={canPreviousPage}
          loading={loading}
          visibleColumns={visibleColumns}
          pagination={false}
          pageSize={pageSize}
          setPageSize={setPageSize}
        />
      </div>
    </div>
  );
}

export default DefaultCertificateTemplate;

const StyledCertificateIcon = styled(GrCertificate)`
  path {
    stroke: ${(props) => props.color};
    font-size: ${(props) => props.size};
  }
`;
